/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-lonely-if */
/* eslint-disable no-unused-expressions */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { FC, useEffect, useState, useCallback } from 'react';
import { RouteComponentProps, useParams, withRouter } from 'react-router-dom';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import { useSelector } from 'react-redux';
import Spinner from '@salesforce/design-system-react/components/spinner';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import moment from 'moment';
import CycleCountDetailHeader from './CycleCountDetailHeader';
import NewCycleCount from '../NewCycleCount';
import { GET_CYCLE_COUNT_DETAILS } from '../../../graphql/getCycleCountDetails';
import CANCEL_CYCLE_COUNT from '../../../graphql/mutations/cancleCycleCount';
import CREATE_CYCLE_COUNT from '../../../graphql/mutations/createCycleCount';
import CancelEventModal from '../../CreateEditSurgeryEvent/CancelEventCreationModal';
import useSnackBar from '../../../util/customHooks/useSnackBar';
import { NOTIFY_TYPE, SYSTEM_NAME ,DEFAULT_VERSION} from '../../../util/constants';
import SnackBar from '../../Shared/SnackBar';
import { GET_CYCLE_COUNT_LINE_ITEM_DETAILS } from '../../../graphql/getCycleCountLineItemDetails';
import CycleCountDetailTable from './CycleCountDetailTable';
import { excelExport, getUSDString } from '../../../util/utilityFunctions';
import { getUserInfo } from '../../../store/ducks/userInfo';

interface Props {
  type: string;
}

type ReturnParams = {
  cycleCountExternalId: string;
  type: string;
  caseExternalId: string | undefined;
  orderId: string | undefined;
  opsAction?: string;
};

// eslint-disable-next-line no-empty-pattern
const CycleCountDetail: FC<RouteComponentProps> = ({ location }) => {
  const { state } = location;
  const useParam = useParams<ReturnParams>();
  const parameters = (state || useParam) as ReturnParams;
  const { cycleCountExternalId, opsAction } = parameters;
  // const { cycleCountExternalId, opsAction } = state;
  const [isEdit, setIsEdit] = useState(false);
  const [isCycleCountStarted, startCycleCount] = useState(false);
  const { open, notification, openSnackBar } = useSnackBar();
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [cycleCountDetails, setcycleCountDetails] = useState<any>(null);
  const [oldStartDate, setOldStartDate] = useState('');
  const [canceModalVisible, setCanceModalVisible] = useState(false);
  const [createCycleCount, { data: createCycleCountData }] = useMutation(CREATE_CYCLE_COUNT);
  const [cycleCountLineItemsDetails, setcycleCountLineItemsDetails] = useState<any>(null);
  const [cycleCountLineItemsDetailsForExcel, setCycleCountLineItemsDetailsForExcel] = useState<any>(
    null
  );
  let allDataJson: any;
  let UploadData: any;
  const filtercheck = localStorage?.getItem('CCFilters');
  const userInfo = useSelector(getUserInfo);
  const isOps = userInfo?.personas?.includes('Branch Op') || false;
  const inProgress = cycleCountDetails && cycleCountDetails.status.toLowerCase() === 'in progress';

  const [getCycleCountDetails, { data: cycleCountDetailsData, refetch, loading }] = useLazyQuery(
    GET_CYCLE_COUNT_DETAILS,
    {
      fetchPolicy: 'no-cache',
    }
  );
  const [
    setCancelCycleCount,
    { data: cancelCycleCount, loading: cancelCycleCountLoading },
  ] = useMutation(CANCEL_CYCLE_COUNT);
  const [
    getCycleCountLineItemsDetails,
    {
      data: cycleCountDetailsLineItemsData,
      refetch: refetchCycleCountDetailsLineItemsData,
      loading: lineItemLoading,
    },
  ] = useLazyQuery(GET_CYCLE_COUNT_LINE_ITEM_DETAILS, {
    fetchPolicy: 'no-cache',
  });
  const [
    getCycleCountLineItemsDetailsForExcel,
    {
      data: cycleCountDetailsLineItemsDataForExcel,
      refetch: refetchCycleCountDetailsLineItemsDataForExcel,
      loading: lineItemLoadingForExcel,
    },
  ] = useLazyQuery(GET_CYCLE_COUNT_LINE_ITEM_DETAILS, {
    fetchPolicy: 'no-cache',
  });
  useEffect(() => {
    if (cycleCountDetails) {
      setOldStartDate(
        `${moment(cycleCountDetails.startDate).format('YYYY-MM-DD')} - ${moment(
          cycleCountDetails.endDate
        ).format('YYYY-MM-DD')}`
      );
    }
  }, [cycleCountDetails]);
  const validateLotNumber = () => {
    let lotNumberMissing: any = false;

    if (cycleCountDetails && cycleCountDetails.lineItems) {
      cycleCountDetails.lineItems.forEach((item: any) => {
        if (!item.lotNumber) {
          lotNumberMissing = true;
        }
      });
    }
    return lotNumberMissing;
  };

  const displaySnackBar = (type: string, message: string) => {
    openSnackBar(type, message);
  };

  const handleCancelButton = (): void => {
    setCanceModalVisible(!canceModalVisible);
  };

  const handleCancelModalEdit = (): void => {
    setCanceModalVisible(!canceModalVisible);
  };

  const handleCancelModalConfirmPressEdit = (): void => {
    setCanceModalVisible(!canceModalVisible);
    setIsEdit(!isEdit);
  };

  const handleCancelModal = (): void => {
    setShowCancelPopup(!showCancelPopup);
  };

  const updateCycleCountDetails = (eventType: any): void => {
    if (!isOps && inProgress && eventType === 'RepSubmit' && validateLotNumber()) {
      openSnackBar(NOTIFY_TYPE.ERROR, 'Lot number is missing for one or more items');
      return;
    }
    if (eventType === 'RepSubmit') {
      if (cycleCountDetails && cycleCountDetails?.lineItems?.length === 0) {
        return;
      }
    }

    let mutation: any = {};
    mutation = {
      caseId: null,
      caseExternalId: cycleCountDetails.caseExternalId,
      cycleCountExternalId: cycleCountDetails.cycleCountExternalId,
      cycleCountId: null,
      formType: 'Update',
      submitType: eventType,
      oldDate: oldStartDate,
      inventoryConsignmentHold: true,
      reasonCodeForUnscannedItems: false,
      startDate: cycleCountDetails.startDate,
      endDate: cycleCountDetails.endDate,
      system: SYSTEM_NAME,
      version: process.env.REACT_APP_VERSION || DEFAULT_VERSION,
    };

    createCycleCount({
      variables: mutation,
    })
      .then(response => {
        if (
          response &&
          response.data &&
          response.data.createCycleCount &&
          response.data.createCycleCount.message === 'success'
        ) {
          setShowCancelPopup(false);

          if (eventType !== 'RepStart') {
            openSnackBar(NOTIFY_TYPE.SUCCESS, 'Cycle count updated successfully');
          }

          if (refetch) {
            refetch();
          }
          refetchCycleCountDetailsLineItemsData();
        }
      })
      .catch(error => {
        const errors = error.graphQLErrors?.map((er: any) => er.message) || [];
        console.log('errors', errors);
        // Show error to user
        if (errors.length > 0) {
          openSnackBar(NOTIFY_TYPE.ERROR, errors[0]);
        } else {
          openSnackBar(NOTIFY_TYPE.ERROR, 'An error occurred while updating the cycle count');
        }
      });
  };

  useEffect(() => {
    if (cycleCountExternalId) {
      getCycleCountDetails({
        variables: {
          externalId: cycleCountExternalId,
        },
      });
    } else {
      window.history.back();
    }
  }, [getCycleCountDetails, cycleCountExternalId]);

  useEffect(() => {
    if (cycleCountDetailsData && cycleCountDetailsData.getCycleCountDetails) {
      const details = cycleCountDetailsData.getCycleCountDetails;
      if (!isOps) {
        const lineItems = details.lineItems.filter(
          (x: { createdBy: string | undefined }) => x.createdBy === userInfo?.id
        );
        details.lineItems = lineItems;
      }
      setcycleCountDetails(details);
    }
  }, [cycleCountDetailsData]);

  const handleModalToggle = useCallback((): void => {
    setIsEdit(!isEdit);
  }, [isEdit]);

  const handleCancelModalConfirmPress = (): void => {
    updateCycleCountDetails('Cancel');
  };
  useEffect(() => {
    if (cycleCountExternalId) {
      getCycleCountLineItemsDetailsForExcel({
        variables: {
          externalId: cycleCountExternalId,
        },
      });
    }
  }, [getCycleCountLineItemsDetailsForExcel, cycleCountExternalId]);

  useEffect(() => {
    if (cycleCountExternalId) {
      getCycleCountLineItemsDetails({
        variables: {
          externalId: cycleCountExternalId,
        },
      });
    }
  }, [getCycleCountLineItemsDetails, cycleCountExternalId]);

  useEffect(() => {
    if (
      cycleCountDetailsLineItemsData &&
      cycleCountDetailsLineItemsData.getCycleCountLineItemDetails
    ) {
      setcycleCountLineItemsDetails(cycleCountDetailsLineItemsData.getCycleCountLineItemDetails);
    }
  }, [cycleCountDetailsLineItemsData, refetchCycleCountDetailsLineItemsData]);

  useEffect(() => {
    if (
      cycleCountDetailsLineItemsDataForExcel &&
      cycleCountDetailsLineItemsDataForExcel.getCycleCountLineItemDetails
    ) {
      setCycleCountLineItemsDetailsForExcel(
        cycleCountDetailsLineItemsDataForExcel.getCycleCountLineItemDetails
      );
    }
  }, [cycleCountDetailsLineItemsDataForExcel, refetchCycleCountDetailsLineItemsDataForExcel]);

  const updatedTotalCost = (cost: any): string => {
    // eslint-disable-next-line eqeqeq
    return cost === null || cost == '0' || cost === undefined ? '$0.00' : cost;
  };

  const formatCreatedByField = (
    createdByDetails: { [key: string]: any }[], // Array of objects with dynamic keys
    field: string // The field to extract
  ): string => {
    return JSON.stringify(
      createdByDetails?.length ? createdByDetails.map((i: { [key: string]: any }) => i[field]) : []
    );
  };

  const consolidateLineItems = (lineItems: any[]) => {
    if (!lineItems || !Array.isArray(lineItems) || lineItems.length === 0) {
      return [];
    }
    const DEFAULT_COST_VALUE = '$0.00';

    return lineItems.reduce((accumulator: any[], currentItem: any) => {
      if (!currentItem || !currentItem.productNumber) {
        console.warn('Invalid line item detected, skipping:', currentItem);
        return accumulator;
      }

      const existingItemIndex = accumulator.findIndex(
        item =>
          item &&
          item.productNumber === currentItem.productNumber &&
          item.lotNumber === currentItem.lotNumber
      );

      if (existingItemIndex !== -1) {
        const existingItem = accumulator[existingItemIndex];

        const existingQuantity = existingItem?.quantity ? parseInt(existingItem.quantity, 10) : 0;
        const currentQuantity = currentItem?.quantity ? parseInt(currentItem.quantity, 10) : 0;
        const existingAvailableQuantity = existingItem?.availablequantity
          ? parseInt(existingItem.availablequantity, 10)
          : 0;
        const currentAvailableQuantity = currentItem?.availablequantity
          ? parseInt(currentItem.availablequantity, 10)
          : 0;
        const existingQuantityDifference = existingItem?.quantitydifference
          ? parseInt(existingItem.quantitydifference, 10)
          : 0;
        const currentQuantityDifference = currentItem?.quantitydifference
          ? parseInt(currentItem.quantitydifference, 10)
          : 0;

        const newQuantity = existingQuantity + currentQuantity;
        const newAvailableQuantity = existingAvailableQuantity + currentAvailableQuantity;
        const newQuantityDifference = existingQuantityDifference + currentQuantityDifference;

        let formattedCost = DEFAULT_COST_VALUE;
        try {
          const existingCostStr = existingItem?.costVariance || DEFAULT_COST_VALUE;
          const currentCostStr = currentItem?.costVariance || DEFAULT_COST_VALUE;

          const existingCost =
            parseFloat(existingCostStr.replace(/[$(),]/g, '').replace('-', '') || '0') *
            (existingCostStr.includes('(') ? -1 : 1);
          const currentCost =
            parseFloat(currentCostStr.replace(/[$(),]/g, '').replace('-', '') || '0') *
            (currentCostStr.includes('(') ? -1 : 1);

          const totalCost = existingCost + currentCost;
          formattedCost =
            totalCost < 0 ? `($${Math.abs(totalCost).toFixed(2)})` : `$${totalCost.toFixed(2)}`;
        } catch (error) {
          console.error('Error calculating cost variance:', error);
          formattedCost = DEFAULT_COST_VALUE;
        }

        const existingCreatedByDetails = existingItem?.createdByDetails || [];
        const currentCreatedByDetails = currentItem?.createdByDetails || [];

        accumulator[existingItemIndex] = {
          ...existingItem,
          quantity: newQuantity.toString(),
          availablequantity: newAvailableQuantity.toString(),
          quantitydifference: newQuantityDifference.toString(),
          deltaQty: newQuantityDifference.toString(),
          costVariance: formattedCost,
          createdByDetails: [...existingCreatedByDetails, ...currentCreatedByDetails],
        };
      } else {
        accumulator.push({
          ...currentItem,
          createdByDetails: currentItem?.createdByDetails ? [...currentItem.createdByDetails] : [],
          costVariance: currentItem?.costVariance || DEFAULT_COST_VALUE,
          quantity: currentItem?.quantity || '0',
          availablequantity: currentItem?.availablequantity || '0',
          quantitydifference: currentItem?.quantitydifference || '0',
          deltaQty: currentItem?.deltaQty || '0',
        });
      }
      return accumulator;
    }, []);
  };

  const lineData =
    cycleCountDetailsLineItemsDataForExcel?.getCycleCountLineItemDetails?.[0] ||
    cycleCountDetailsLineItemsDataForExcel?.getCycleCountLineItemDetails;
  const lineDataForExcel =
    cycleCountDetailsLineItemsDataForExcel?.getCycleCountLineItemDetails?.[0]?.lineItems ||
    cycleCountDetailsLineItemsDataForExcel?.getCycleCountLineItemDetails;
  if (lineDataForExcel?.length > 0) {
    const consolidateLineItemsExcel = consolidateLineItems(lineDataForExcel);
    allDataJson = consolidateLineItemsExcel.map((items: any) => {
      if (cycleCountDetails?.status.toLowerCase() === 'completed') {
        return {
          'SAP: Plant': items.plant,
          'SAP: Storage Location': items.storageLocation,
          Customer: items.soldTo,
          Org: cycleCountDetails?.fieldOrg ? cycleCountDetails?.fieldOrg : '',
          Sub: cycleCountDetails?.inventoryLocation ? cycleCountDetails.inventoryLocation : '',
          Sku: items.productNumber,
          Batch:
            items.isLotNumber && items.lotNumber
              ? items.lotNumber
              : items.lotNumber && !items.serialNumber
              ? items.lotNumber
              : null,
          'SAP Unit of Entry': items.unitOfMeasure,
          'Serial Number': items.serialNumber && !items.isLotNumber ? items.serialNumber : null,
          'Movement Type': items.movementType,
          'Stock Type': items.stockType,
          'Special Stock Indicator': items.specialStockIndicator,
          'Expected Qty': items?.availablequantity,
          'Counted Qty': items?.quantity,
          'Delta Qty': parseFloat(items.quantitydifference).toFixed(2),
          'Part Line Comments': JSON.stringify(
            items?.createdByDetails?.map((itemscomments: any) => {
              return itemscomments.comments !== null
                ? itemscomments.comments.map((comment: any) => {
                    return comment.comments === null ? '' : comment.comments;
                  })
                : '';
            })
          ),
          'Header Comments': cycleCountDetails?.comments[0]?.value,
          'Cost Delta': updatedTotalCost(items?.costVariance),
          '': '',
          [`Overage ${updatedTotalCost(lineData?.overagePrice)}`]: '',
          [`Shortage ${updatedTotalCost(lineData?.shortagePrice)}`]: '',
          [`Total Cost Delta ${updatedTotalCost(lineData?.totalPrice)}`]: '',
          'Sales Rep/Ops': formatCreatedByField(items.createdByDetails, 'createdByName'),
          'Individual quantities': formatCreatedByField(items.createdByDetails, 'quantity'),
        };
      }
      return {
        'SAP: Plant': items.plant,
        'SAP: Storage Location': items.storageLocation,
        Customer: items.soldTo,
        Org: cycleCountDetails?.fieldOrg ? cycleCountDetails?.fieldOrg : '',
        Sub: cycleCountDetails?.inventoryLocation ? cycleCountDetails.inventoryLocation : '',
        Sku: items.productNumber,
        Batch:
          items.isLotNumber && items.lotNumber
            ? items.lotNumber
            : items.lotNumber && !items.serialNumber
            ? items.lotNumber
            : null,
        'SAP Unit of Entry': items.unitOfMeasure,
        'Serial Number': items.serialNumber && !items.isLotNumber ? items.serialNumber : null,
        'Movement Type': items.movementType,
        'Stock Type': items.stockType,
        'Special Stock Indicator': items.specialStockIndicator,
        'Expected Qty': items?.availablequantity,
        'Counted Qty': items?.quantity,
        'Delta Qty': parseFloat(items.quantitydifference).toFixed(2),
        'Part Line Comments': JSON.stringify(
          items?.createdByDetails?.map((itemscomments: any) => {
            return itemscomments.comments !== null
              ? itemscomments.comments.map((comment: any) => {
                  return comment.comments === null ? '' : comment.comments;
                })
              : '';
          })
        ),
        'Header Comments': cycleCountDetails?.comments[0]?.value,
        'Sales Rep/Ops': formatCreatedByField(items.createdByDetails, 'createdByName'),
        'Individual quantities': formatCreatedByField(items.createdByDetails, 'quantity'),
      };
    });
  } else {
    allDataJson = [
      {
        'SAP: Plant': null,
        'SAP: Storage Location': null,
        Customer: null,
        Org: null,
        Sub: null,
        Sku: null,
        Batch: null,
        'SAP Unit of Entry': null,
        'Serial Number': null,
        'Movement Type': null,
        'Stock Type': null,
        'Special Stock Indicator': null,
        'Expected Qty': null,
        'Counted Qty': null,
        'Delta Qty': null,
        'Part Line Comments': [],
        'Header Comments': [],
        'Sales Rep/Ops': [],
        'Individual quantities': [],
      },
    ];
  }

  if (cycleCountDetailsLineItemsData?.getCycleCountLineItemDetails?.length > 0) {
    UploadData = cycleCountDetailsLineItemsData?.getCycleCountLineItemDetails.map((items: any) => {
      if (filtercheck === 'true') {
        return {
          'Part Number': items.productNumber,
          'Part Description': items.productdescription,
          'Lot Number': items.lotNumber,
          'EIM Reserved': items.pendingeimtransaction,
          'Counted Qty': items.quantity,
          'Expected Qty': items.availablequantity,
          'Qty Delta': parseFloat(items.quantitydifference).toFixed(2),
          'Cost Delta': getUSDString(items.costVariance.toString()),
        };
      }
      return {
        Org: cycleCountDetails?.fieldOrg ? cycleCountDetails?.fieldOrg : '',
        Sub: cycleCountDetails?.inventoryLocation ? cycleCountDetails.inventoryLocation : '',
        Sku: items.productNumber,
        LotNumber: items.lotNumber,
        Qty: items.quantitydifference,
      };
    });
  } else {
    UploadData = [
      {
        Org: null,
        Sub: null,
        Sku: null,
        LotNumber: null,
        Qty: null,
      },
    ];
  }

  const handleActionDropdownSelect = (option: any): void => {
    if (option.value === 'edit' && !option.disabled) {
      setIsEdit(true);
    } else if (option.value === 'cancel' && !option.disabled) {
      setShowCancelPopup(true);
    } else if (option.value === 'submit' && !option.disabled) {
      updateCycleCountDetails('RepSubmit');
    } else if (option.value === 'audit_complete' && !option.disabled) {
      updateCycleCountDetails('OPSAuditComplete');
    } else if (option.value === 'complete' && !option.disabled) {
      updateCycleCountDetails('OPSComplete');
    } else if (option.value === 'set_in_progress' && !option.disabled) {
      updateCycleCountDetails('In Progress');
    } else if (option.value === 'export' && !option.disabled) {
      excelExport(
        [{ title: 'All Data', data: allDataJson }],
        `Cycle Count ID ${cycleCountDetails?.caseNumber}.xlsx`
      );
    }
  };

  return (
    <IconSettings iconPath="/icons">
      <SnackBar open={open} notification={notification} />
      {loading || lineItemLoading || lineItemLoadingForExcel ? (
        <Spinner size="large" variant="base" assistiveText={{ label: 'Loading...' }} />
      ) : (
        cycleCountDetails && (
          <CycleCountDetailHeader
            cycleCountDetails={cycleCountDetails}
            refetch={() =>
              getCycleCountDetails({
                variables: {
                  externalId: cycleCountExternalId,
                },
              })
            }
            handleActionDropdownSelect={handleActionDropdownSelect}
            opsActionType={opsAction}
          />
        )
      )}
      <CycleCountDetailTable
        refetchCycleCountDetails={() =>
          getCycleCountDetails({
            variables: {
              externalId: cycleCountExternalId,
            },
          })
        }
        refetch={refetchCycleCountDetailsLineItemsData}
        getCycleCountLineItemsDetails={getCycleCountLineItemsDetails}
        getCycleCountLineItemsDetailsForExcel={getCycleCountLineItemsDetailsForExcel}
        cycleCountDetails={cycleCountDetails}
        cycleCountDetailTable={cycleCountLineItemsDetails}
        opsActionType={opsAction}
        displaySnackBar={displaySnackBar}
      />
      {isEdit && (
        <NewCycleCount
          isOpen={isEdit}
          toggleOpen={handleModalToggle}
          refetch={refetch}
          cycleCountDetail={cycleCountDetails}
          eventType="Edit"
          handleCancelButton={handleCancelButton}
        />
      )}
      {showCancelPopup && (
        <CancelEventModal
          isCycleCount
          canceModalVisible={showCancelPopup}
          handleCancelModal={handleCancelModal}
          handleCancelModalConfirmPress={handleCancelModalConfirmPress}
        />
      )}
      {canceModalVisible && (
        <CancelEventModal
          canceModalVisible={canceModalVisible}
          handleCancelModal={handleCancelModalEdit}
          handleCancelModalConfirmPress={handleCancelModalConfirmPressEdit}
          edit
        />
      )}
    </IconSettings>
  );
};

export default withRouter(CycleCountDetail);
